import { createBrowserRouter, Navigate } from 'react-router-dom'
import PortalLayout from '@components/layout/PortalLayout/PortalLayout'
import PrivateRoute from './PrivateRoute'

// Lazy load screens
import { lazy } from 'react'
const Login = lazy(() => import('@screens/Login/Login'))
const AuthSuccess = lazy(() => import('@screens/AuthSuccess/AuthSuccess'))
const Dashboard = lazy(() => import('@screens/Dashboard/Dashboard'))
const Search = lazy(() => import('@screens/Search/Search'))
const EntityDetail = lazy(() => import('@screens/EntityDetail/EntityDetail'))
const Hits = lazy(() => import('@screens/Hits/Hits'))
const DataPool = lazy(() => import('@screens/DataPool/DataPool'))
const Jobs = lazy(() => import('@screens/Jobs/Jobs'))
const Analytics = lazy(() => import('@screens/Analytics/Analytics'))
const AuditLog = lazy(() => import('@screens/AuditLog/AuditLog'))
const Users = lazy(() => import('@screens/Users/Users'))
const Profile = lazy(() => import('@screens/Profile/Profile'))
const Admin = lazy(() => import('@screens/Admin/Admin'))

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/auth/success/:token',
    element: <AuthSuccess />,
  },
  {
    path: '/',
    element: (
      <PrivateRoute>
        <PortalLayout />
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'search',
        element: <Search />,
      },
      {
        path: 'entity/:entityId',
        element: <EntityDetail />,
      },
      {
        path: 'hits',
        element: <Hits />,
      },
      {
        path: 'data-pool',
        element: <DataPool />,
      },
      {
        path: 'jobs',
        element: <Jobs />,
      },
      {
        path: 'analytics',
        element: <Analytics />,
      },
      {
        path: 'audit-log',
        element: <AuditLog />,
      },
      {
        path: 'users',
        element: <Users />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
      {
        path: 'admin',
        element: <Admin />,
      },
    ],
  },
])

export default router
